/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import React from 'react';
import { TextField } from '@mui/material';
import { makeAppStyles } from '../../../styles/makeStyles';

const useStyles = makeAppStyles()(() => ({
  input: {
    height: '36px',
    width: '100%',
  }
}));

const CustomTextField = ({ inputProps = {}, ...props }) => {
  const { classes } = useStyles();

  return (
    <TextField
      className={classes.input}
      inputProps={{
        ...inputProps,
        autoComplete: 'off',
        form: {
          autoComplete: 'off',
        },
      }}
      variant="standard"
      {...props}
    />
  );
};

export default CustomTextField;